import React, { Component, Fragment } from 'react';
import { fetchDashboardReport, fetchReports } from '../login/api.actions';
import { connect } from 'react-redux';
import { Overlay, Reports } from 'clorian-frontend-components';
import {
  Nav,
  NavItem,
  TabContainer,
  TabContent,
  TabPane
} from 'react-bootstrap';

class ReportsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardUrl: '',
      disabled: ''
    };
    this.handleDashboard = this.handleDashboard.bind(this);
  }

  componentDidMount() {
      const { dispatch } = this.props;
      dispatch(fetchReports()).then(({ response }) => {
          this.handleDashboard(response[0]?.url);
      });
  }

  handleDashboard(url) {
    const { dispatch } = this.props;
    const request = [
      { name: 'pos_id', value: [sessionStorage.getItem('id_pos')] }
    ];
    this.setState({
      disabled: true
    });

    if (url && url.includes('metabase')) {
      dispatch(fetchDashboardReport(url, request)).then(({ response }) => {
        if (response) {
          this.setState({
            dashboardUrl: response && response.iframeUrl,
            disabled: false
          });
        } else {
          this.setState({
            disabled: false
          });
        }
      });
    } else {
      this.setState({
        disabled: false,
        dashboardUrl: url
      });
    }
  }

  render() {
    let { dashboardUrl, disabled } = this.state;
    const { reportsList } = this.props;

    return (
      <div className="reports">
        <Overlay loading={disabled} />
        {reportsList &&
          reportsList.length > 0 && (
            <TabContainer defaultActiveKey={reportsList[0].reportId}>
              <Fragment>
                <Nav bsStyle="tabs">
                  {reportsList.map(report => (
                    <NavItem eventKey={report.reportId}>{report.name}</NavItem>
                  ))}
                </Nav>

                <TabContent>
                  {reportsList.map(report => (
                    <TabPane
                      eventKey={report.reportId}
                      onEnter={() => this.handleDashboard(report.url)}
                      mountOnEnter={true}
                    >
                      <Reports dashboardUrl={dashboardUrl} />
                    </TabPane>
                  ))}
                </TabContent>
              </Fragment>
            </TabContainer>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { reports } = state;
  return {
    reportsList: reports.reports
  };
}

export default connect(mapStateToProps)(ReportsContainer);
